import { createRegionNotificationInstances, RegionNotificationUI } from './regionNotificationUI';
import Axios from 'axios';
import { API } from '../api/api';

class RegionNotification {
  public constructor(private ui: RegionNotificationUI) {
    this.checkRegionServers();
  }

  public checkRegionServers() {
    const otherRegion = window.regionPrefix === 'int' ? 'eur' : 'int';
    Axios.get(
      API.buildUrl(otherRegion + '/api/roxy/orders'),
      {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    ).then((response) => {
      if (parseInt(response.data) > 0) {
        this.ui.showNotification();
      }
    })
  }
}

export function initRegionNotification() {
  return createRegionNotificationInstances().map((ui: RegionNotificationUI) => {
    return new RegionNotification(ui);
  });
}
